import { TruncatePrice } from "Util/NumberUtils";
import { PaymentSummaryUtil } from "Util/PaymentSummaryUtil";
import { SummaryCard } from "../Card/SummaryCard";

export type OrderItem = {
	id: string;
	name: string;
	price: number;
	originalPrice: number;
}

export type PaymentSummary = {
	billedTo: string;
	orderItems: OrderItem[];
	gstRate: number;
}

type PaymentSummaryCardProps =  {
	paymentSummary: PaymentSummary;
};

export function PaymentSummaryCard ({paymentSummary}: PaymentSummaryCardProps) {
	const orginalSubTotal = PaymentSummaryUtil.getOriginalSubTotal(paymentSummary);
	const subTotal = PaymentSummaryUtil.getSubTotal(paymentSummary);
	const gstAmount = PaymentSummaryUtil.getGstAmount(paymentSummary);
	const totalAmount = PaymentSummaryUtil.getTotalIncludingGst(paymentSummary);

	return (
		<>
			<SummaryCard
				title="Payment Summary"
				description={<p><strong>This will be billed to {paymentSummary.billedTo}</strong>.</p>}
			>
				<p><span><strong>Subtotal: </strong>{(orginalSubTotal !== subTotal) && (
					<>
						<del>${TruncatePrice(orginalSubTotal)}</del>&nbsp;&nbsp;
					</>
				)}${TruncatePrice(subTotal)}</span></p>
				<p><span><strong>GST ({paymentSummary.gstRate * 100}%): </strong> ${TruncatePrice(gstAmount)}</span></p>
				<p>
					<span>
						<strong>Total: </strong>
						${TruncatePrice(totalAmount)}
					</span>
				</p>
			</SummaryCard>
		</>
	);
};